import styled from 'styled-components';

const NotesHeaderContainer = styled.h4`
  padding: 0px var(--side-panel-padding);
  button {
    line-height: inherit;
  }
`;

export default NotesHeaderContainer;
